import * as React from 'react';
import { scrollWithDelay } from '../../util/scrollWithDelay.js';
import { useDirectionContext, Direction } from '../../contexts/session/Locale.js';
import { Keys } from '../../types/Keys.js';

var scrollStartEndTimeDelay = 200;
var getTabId = function getTabId(id, index) {
  return "".concat(id, "-tab-").concat(index + 1);
};
var getPanelId = function getPanelId(id, index) {
  return "".concat(id, "-panel-").concat(index + 1);
};
var useTabsKeyboardNavigation = function useTabsKeyboardNavigation(totalTabItems, id, scrollRef, active, changeTab) {
  var direction = useDirectionContext();
  var isLastTab = React.useCallback(function (index) {
    return index === totalTabItems - 1;
  }, [totalTabItems]);
  var isFirstTab = React.useCallback(function (index) {
    return index === 0;
  }, []);
  var isRtl = React.useMemo(function () {
    return direction === Direction.RTL;
  }, [direction]);
  var moveFocusToTab = React.useCallback(function (currentTab) {
    currentTab === null || currentTab === void 0 || currentTab.focus();
  }, []);
  var moveFocusToNextTab = React.useCallback(function (index) {
    if (isLastTab(index)) {
      moveFocusToTab(document.getElementById(getTabId(id, 0)));
      scrollWithDelay(scrollRef, {
        left: 0,
        behavior: 'smooth'
      }, scrollStartEndTimeDelay);
    } else {
      moveFocusToTab(document.getElementById(getTabId(id, index + 1)));
    }
  }, [id, isLastTab, moveFocusToTab, scrollRef]);
  var moveFocusToPreviousTab = React.useCallback(function (index) {
    if (isFirstTab(index)) {
      var _scrollRef$current;
      moveFocusToTab(document.getElementById(getTabId(id, totalTabItems - 1)));
      scrollWithDelay(scrollRef, {
        left: (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollWidth,
        behavior: 'smooth'
      });
    } else {
      moveFocusToTab(document.getElementById(getTabId(id, index - 1)));
    }
  }, [id, isFirstTab, moveFocusToTab, scrollRef, totalTabItems]);
  var handleKeyDown = React.useCallback(function (e, index) {
    var flag = false;
    switch (e.key) {
      case Keys.ArrowRight:
        {
          if (isRtl) {
            moveFocusToPreviousTab(index);
          } else {
            moveFocusToNextTab(index);
          }
          flag = true;
          break;
        }
      case Keys.ArrowLeft:
        {
          if (isRtl) {
            moveFocusToNextTab(index);
          } else {
            moveFocusToPreviousTab(index);
          }
          flag = true;
          break;
        }
      case Keys.Home:
        {
          moveFocusToTab(document.getElementById(getTabId(id, 0)));
          flag = true;
          break;
        }
      case Keys.End:
        {
          moveFocusToTab(document.getElementById(getTabId(id, totalTabItems - 1)));
          flag = true;
          break;
        }
      case Keys.Enter:
      case Keys.Space:
        if (index !== active) {
          changeTab(index);
        }
        flag = true;
        break;
    }
    if (flag) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, [isRtl, moveFocusToNextTab, moveFocusToPreviousTab, moveFocusToTab, active, changeTab, id, totalTabItems]);
  return handleKeyDown;
};

export { getPanelId, getTabId, useTabsKeyboardNavigation };
//# sourceMappingURL=useTabsKeyboardNavigation.js.map
